/**
 * The ordered rule registry (docs/event-model.md §5). Each group lives in
 * its own file, owned by one Phase 4 lane; add a new group by appending an
 * import and a spread below, never by reordering.
 *
 * Order: contextual escalation first (so later rules see escalated
 * severities), then canary flows, then tampering and evasion.
 */
import type { Rule } from "../types";
import { CANARY_RULES } from "./canary";
import { ESCALATION_RULES } from "./escalation";
import { EVASION_RULES } from "./evasion";
import { TAMPER_RULES } from "./tamper";

export const RULES: readonly Rule[] = [
  ...ESCALATION_RULES, // lane C
  ...CANARY_RULES, // lane A
  ...TAMPER_RULES, // lane B
  ...EVASION_RULES, // lane B
];
